import {
  type ProgramSchedule,
  type ProgramWeek,
  type WeekDay,
} from "@fitness-app/data-models/entities/TrainingProgram";

export const programWeekDays: WeekDay[] = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const createEmptyProgramWeek = (): ProgramWeek => ({
  monday: { workoutDay: null },
  tuesday: { workoutDay: null },
  wednesday: { workoutDay: null },
  thursday: { workoutDay: null },
  friday: { workoutDay: null },
  saturday: { workoutDay: null },
  sunday: { workoutDay: null },
});

export const removeWorkoutFromProgramSchedule = (
  schedule: ProgramSchedule | null,
  workoutId: string,
): ProgramSchedule | null =>
  schedule?.map(
    (week) =>
      Object.fromEntries(
        programWeekDays.map((day) => [
          day,
          {
            workoutDay: week[day]?.workoutDay === workoutId ? null : (week[day]?.workoutDay ?? null),
          },
        ]),
      ) as unknown as ProgramWeek,
  ) as ProgramSchedule | null;

export const getInvalidProgramScheduleWorkoutIds = (schedule: ProgramSchedule | null, workoutIds: string[]) => {
  if (!schedule) return [];

  const validWorkoutIds = new Set(workoutIds);
  const invalidWorkoutIds = new Set<string>();

  for (const week of schedule) {
    for (const day of programWeekDays) {
      const workoutId = week[day]?.workoutDay;
      if (workoutId && !validWorkoutIds.has(workoutId)) invalidWorkoutIds.add(workoutId);
    }
  }

  return [...invalidWorkoutIds];
};
